module.exports = "/_next/static/images/DeletionRequests@2x-a125740c11c68b0c8f13fef419b205f1.png";